var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 448 383", fill: "none" }, props),
    React.createElement("rect", { x: "10.5", y: "5.5", width: "121", height: "121", rx: "30.5", fill: "#fff", stroke: "#E6E6E6", opacity: ".4", filter: "url(#a)" }),
    React.createElement("rect", { x: "316.5", y: "5.5", width: "121", height: "121", rx: "30.5", fill: "#fff", stroke: "#E6E6E6", opacity: ".4", filter: "url(#b)" }),
    React.createElement("rect", { x: "10.5", y: "246.5", width: "121", height: "121", rx: "30.5", fill: "#fff", stroke: "#E6E6E6", opacity: ".4", filter: "url(#c)" }),
    React.createElement("rect", { x: "316.5", y: "246.5", width: "121", height: "121", rx: "30.5", fill: "#fff", stroke: "#E6E6E6", opacity: ".4", filter: "url(#d)" }),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "a", x: "0", y: "0", width: "142", height: "142", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
        React.createElement("feOffset", { dy: "5" }),
        React.createElement("feGaussianBlur", { stdDeviation: "5" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })
      ),
      React.createElement(
        "filter",
        { id: "b", x: "306", y: "0", width: "142", height: "142", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
        React.createElement("feOffset", { dy: "5" }),
        React.createElement("feGaussianBlur", { stdDeviation: "5" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })
      ),
      React.createElement(
        "filter",
        { id: "c", x: "0", y: "241", width: "142", height: "142", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
        React.createElement("feOffset", { dy: "5" }),
        React.createElement("feGaussianBlur", { stdDeviation: "5" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })
      ),
      React.createElement(
        "filter",
        { id: "d", x: "306", y: "241", width: "142", height: "142", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
        React.createElement("feOffset", { dy: "5" }),
        React.createElement("feGaussianBlur", { stdDeviation: "5" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })
      )
    )
  );
});